import { CalendarDays, MapPin, Users } from "lucide-react";
import { IMG, dayLabel } from "./data";

export const EventsHero = ({ next }) => (
  <section className="relative bg-[#0A0A0A] text-white overflow-hidden" data-testid="events-hero">
    <img src={IMG.hero} alt="Guests networking at a coffee event" className="absolute inset-0 w-full h-full object-cover opacity-30" />
    <div className="relative max-w-7xl mx-auto px-5 py-20 lg:py-28 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-7">
        <p className="overline text-[#E5332A]">Africa Brew Brief Events · London</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-4 leading-[1.05]">The Origin Cup</h1>
        <p className="font-display text-xl sm:text-2xl mt-3 text-white/90">African Coffee. Curated Networking.</p>
        <p className="mt-6 text-white/75 max-w-xl leading-relaxed">
          Africa Brew Brief hosts curated events in London that put African origins at the centre of serious conversation,
          genuine connection and commercial opportunity. Our flagship is The Origin Cup: London's only monthly premium coffee
          and networking experience built entirely around African coffee origins.
        </p>
        <div className="flex flex-wrap gap-3 mt-8">
          <a href="#register" data-testid="events-hero-book-btn" className="bg-[#E5332A] hover:bg-[#B8241C] px-6 py-3 text-sm font-semibold transition-colors">Book a seat</a>
          <a href="#partner" data-testid="events-hero-partner-btn" className="border border-white/40 hover:bg-white/10 px-6 py-3 text-sm transition-colors">Sponsor or partner</a>
        </div>
      </div>
      {next && (
        <div className="lg:col-span-5 self-end bg-white text-[#0A0A0A] p-6 border-t-4 border-[#E5332A]" data-testid="events-next-session">
          <p className="overline text-[#E5332A]">Next session · {next.label}</p>
          <p className="font-display text-3xl font-bold mt-2">{next.country}</p>
          <p className="text-sm text-[#575757] mt-1">{next.region}</p>
          <div className="mt-5 space-y-2 text-sm">
            <p className="flex items-center gap-2"><CalendarDays size={15} className="text-[#E5332A]" /> {dayLabel(next.date, { weekday: "long", day: "numeric", month: "long", year: "numeric" })} · 11:00 to 14:00</p>
            <p className="flex items-center gap-2"><MapPin size={15} className="text-[#E5332A]" /> Central London</p>
            <p className="flex items-center gap-2" data-testid="events-next-seats"><Users size={15} className="text-[#E5332A]" /> {next.seats_left} of 20 seats left</p>
          </div>
        </div>
      )}
    </div>
  </section>
);

const STATS = [["£2.4bn+", "UK specialty coffee market, growing about 9% a year"], ["4,000+", "independent coffee shops in London"],
  ["12%", "of the world's coffee is grown in Africa"], ["20", "guests maximum per session, strictly curated"]];

export const EventsStats = () => (
  <section className="border-b border-[#E7E7E7]">
    <div className="max-w-7xl mx-auto px-5 grid grid-cols-2 lg:grid-cols-4">
      {STATS.map(([n, l]) => (
        <div key={n} className="py-8 pr-6 border-r border-[#E7E7E7] last:border-r-0">
          <p className="font-display text-3xl sm:text-4xl font-bold">{n}</p>
          <p className="text-xs text-[#575757] mt-2 max-w-[14rem]">{l}</p>
        </div>
      ))}
    </div>
  </section>
);
